var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        staticClass: "mt-3",
        attrs: { content: "Datos del Participante", "has-line": "" }
      }),
      _c(
        "div",
        { staticClass: "row my-3" },
        [
          _c("info-field", {
            staticClass: "col-12 col-md-4 my-2",
            attrs: {
              label: "Nombre del Participante:",
              value: _vm.model.studentDetail?.mipeStudent?.fullName
            }
          }),
          _c("info-field", {
            staticClass: "col-12 col-md-4 my-2",
            attrs: { label: "Número de SIE:", value: _vm.model.student?.id }
          }),
          _c("info-field", {
            staticClass: "col-12 col-md-4 my-2",
            attrs: {
              label: "Número de Registro:",
              value: _vm.model.studentDetail?.mipeStudent?.regStudentId
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row my-3" },
        [
          _c("info-field", {
            staticClass: "col-12 col-md-4 my-2",
            attrs: {
              label: "Edad Cronológica:",
              value: _vm.model.studentDetail?.age
            }
          }),
          _c("info-field", {
            staticClass: "col-12 col-md-4 my-2",
            attrs: {
              "format-type": "date",
              label: "Fecha de Nacimiento:",
              value: _vm.model.studentDetail?.birthdate
            }
          }),
          _c("info-field", {
            staticClass: "col-12 col-md-4 my-2",
            attrs: {
              label: "Impedimento:",
              value: _vm.model.studentDetail?.mipeStudent?.impedimentDescription
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "participant-box mt-4" }, [
        _c("div", { staticClass: "participant-box__title" }, [
          _vm._v(" Lenguaje Principal: ")
        ]),
        _c(
          "div",
          { staticClass: "px-3 py-4" },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center flex-wrap primary-language-row"
              },
              [
                _vm._l(_vm.primaryLanguageOptions, function(item) {
                  return _c(
                    "label",
                    {
                      key: item.id,
                      staticClass:
                        "custom-control custom-radio custom-control-inline mb-2"
                    },
                    [
                      _c("input", {
                        staticClass: "custom-control-input",
                        attrs: {
                          disabled: _vm.isReadOnly,
                          name: "primaryLanguage",
                          type: "radio"
                        },
                        domProps: { checked: item.checked },
                        on: {
                          change: function($event) {
                            return _vm.selectPrimaryLanguage(item.id)
                          }
                        }
                      }),
                      _c("span", { staticClass: "custom-control-label" }, [
                        _vm._v(_vm._s(item.name))
                      ])
                    ]
                  )
                }),
                _vm.isOtherLanguageSelected
                  ? _c(
                      "div",
                      { staticClass: "other-language-input ml-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El campo es requerido.",
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        placeholder: "Escriba el lenguaje",
                                        value: _vm.selectedPrimaryLanguageOther
                                      },
                                      on: { input: _vm.updateOtherLanguage }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3862965124
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            ),
            _c("validation-provider", {
              attrs: {
                rules: _vm.primaryLanguageOptions.some(x => x.checked)
                  ? ""
                  : "required"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      errors[0]
                        ? _c("error", {
                            staticClass: "my-3",
                            attrs: {
                              message:
                                "Debe seleccionar un lenguaje principal.",
                              variant: "no-border"
                            }
                          })
                        : _vm._e()
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "participant-box mt-3" }, [
        _c("div", { staticClass: "participant-box__title" }, [
          _vm._v(" Modos de Comunicación o Expresión Oral: ")
        ]),
        _c(
          "div",
          { staticClass: "row px-3 py-4" },
          [
            _vm._l(_vm.communicationOptions, function(item) {
              return _c(
                "div",
                { key: item?.id, staticClass: "col-12 col-md mb-2" },
                [
                  _c("check-box", {
                    class: _vm.isReadOnly ? "disabled-check" : "",
                    attrs: {
                      disabled: _vm.isReadOnly,
                      text: item.name,
                      value: Boolean(item.checked)
                    },
                    on: {
                      input: function($event) {
                        return _vm.toggleCommunication(item?.id)
                      }
                    }
                  })
                ],
                1
              )
            }),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("validation-provider", {
                  attrs: {
                    rules: _vm.communicationOptions.some(x => x.checked)
                      ? ""
                      : "required"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          errors[0]
                            ? _c("error", {
                                staticClass: "my-3",
                                attrs: {
                                  message:
                                    "Debe seleccionar al menos un método de comunicación o expresión oral.",
                                  variant: "no-border"
                                }
                              })
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          2
        )
      ]),
      _c("div", { staticClass: "participant-box mt-3" }, [
        _c("div", { staticClass: "participant-box__title" }, [
          _vm._v(" Otras Condiciones del Estudiante: ")
        ]),
        _c("div", { staticClass: "row px-3 py-4" }, [
          !_vm.isReadOnly
            ? _c(
                "div",
                { staticClass: "col-12 col-md-6 section-divider" },
                [
                  _c("custom-drop-down", {
                    attrs: {
                      id: "otherConditions",
                      clearable: true,
                      disabled: _vm.isReadOnly,
                      fieldkey: "id",
                      fieldname: "name",
                      label: "Otras Condiciones",
                      options: _vm.availableOtherConditions,
                      placeholder: "Seleccione"
                    },
                    on: { input: _vm.onOtherConditionChange },
                    model: {
                      value: _vm.model.otherCondition,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "otherCondition", $$v)
                      },
                      expression: "model.otherCondition"
                    }
                  }),
                  _vm.isOtherConditionSelected
                    ? _c(
                        "div",
                        { staticClass: "mt-2" },
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-input", {
                                        attrs: {
                                          "custom-error-msg":
                                            "El campo es requerido.",
                                          disabled: _vm.isReadOnly,
                                          error: errors[0],
                                          placeholder:
                                            "Especifique la condición",
                                          value: _vm.otherConditionCustomText
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.otherConditionCustomText = $event
                                          }
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2753924613
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.otherConditionError
                    ? _c("error", {
                        staticClass: "mt-2",
                        attrs: {
                          message: _vm.otherConditionError,
                          variant: "no-border"
                        }
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end mt-3" },
                    [
                      !_vm.isReadOnly
                        ? _c(
                            "action-button",
                            {
                              attrs: {
                                i: "fas fa-file-plus",
                                variant: "success"
                              },
                              on: { click: _vm.addOtherCondition }
                            },
                            [_vm._v(" Añadir ")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "col-12 col-md-6" }, [
            _c("div", { staticClass: "color-secondary-6 font-14 mb-3" }, [
              _vm._v(" Seleccionado(s): ")
            ]),
            _c(
              "div",
              { staticClass: "d-flex flex-wrap" },
              [
                _vm._l(_vm.model.otherConditions, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "condition-pill mr-2 mb-2" },
                    [
                      _c("span", [_vm._v(_vm._s(item.other || item.name))]),
                      !_vm.isReadOnly
                        ? _c(
                            "button",
                            {
                              staticClass: "condition-pill__remove",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.removeOtherCondition(index)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "far fa-times-circle text-danger"
                              })
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                }),
                !_vm.model.otherConditions || !_vm.model.otherConditions.length
                  ? _c(
                      "div",
                      { staticClass: "color-secondary-6 font-14" },
                      [
                        _c("div", [_vm._v("-")]),
                        _c("validation-provider", {
                          attrs: {
                            rules:
                              _vm.model.otherConditions.length > 0
                                ? ""
                                : "required"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    errors[0]
                                      ? _c("error", {
                                          attrs: {
                                            message:
                                              "Debe seleccionar al menos una condición del estudiante.",
                                            variant: "no-border"
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2853321966
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }